/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('MenuInformationsCtrl', function($scope, InformationsService) {
    $scope.informations = [];
    $scope.selected     = { };

    $scope.$watch(() => InformationsService.getInformations()
    , function(informations) {
        $scope.selected     = { };
        return $scope.informations = informations.map(function(information) {
            if (($scope.selected[information.id] == null)) { $scope.selected[information.id] = false; }
            return information;
        });
    }
    , true);

    $scope.selectAll = () => Array.from(Object.keys($scope.selected)).map((id) => ($scope.selected[id] = true));

    return $scope.archive = () => (async () => {
        let selected_ids = [];

        for (let id in $scope.selected) {
            if ($scope.selected[id]) selected_ids.push(parseInt(id));
        }

        await InformationsService.archiveInformations(selected_ids);
    })();
});
